type PatientSummarySource = {
  patientName?: unknown;
  patientAge?: unknown;
  patientSex?: unknown;
};

export const normalizeScheduleText = (value?: unknown): string | null => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export const formatScheduleTime = (value?: unknown): string => {
  const normalized = normalizeScheduleText(value);
  return normalized == null || normalized === '-' ? '–' : normalized;
};

export const formatPatientSummary = ({ patientName, patientAge, patientSex }: PatientSummarySource): string =>
  [normalizeScheduleText(patientName) ?? '–', normalizeScheduleText(patientAge), normalizeScheduleText(patientSex)]
    .filter(Boolean)
    .join(' ');
